import { ProgramsSideBarDatamodel } from '../side-bar/programs-side-bar-datamodel';
import appApi from '../../../api/app-api';
import { toast } from 'react-toastify';
import { ReportProgramResponseType } from '../../../api/types/reports/education/programms/report-program-response.type';
import { displayErrorText } from '../../../api/errors/api-error-codes';

export const getProgramsOperations = async (
  filters: ProgramsSideBarDatamodel,
  setLoading: (loading: boolean) => any,
  setData: (data: ReportProgramResponseType[]) => any,
) => {
  try {
    setLoading(true);
    const res = await appApi.getProgramsReport(filters);
    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      setLoading(false);
      return;
    }
    const data: ReportProgramResponseType[] = res.data.body;
    setLoading(false);

    setData(data);
  } catch (e) {
    setLoading(false);
    toast.error('משהו קרה, נסה שוב בעוד מספר רגעים...');
  }
};
